import { render, staticRenderFns } from "./TPPCertificate.vue?vue&type=template&id=5b083bcd&"
import script from "./TPPCertificate.vue?vue&type=script&lang=js&"
export * from "./TPPCertificate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports